<template>
    <div id="footerbox">
        <el-row class="footer_cont_box">
            <el-col :span="14" class="footer_details_box">
                <el-col :span="6">
                    <ul class="">
                        <ol>{{$t('message.footer.wuService')}}</ol>
                        <li v-for="(item,index) in wjfw" :key="index" @click="selectStyle(item,index)">{{$t(item.title)}}</li>
                    </ul>
                </el-col>
                <el-col :span="6">
                    <ul>
                        <ol>{{$t('message.footer.mediaCenter')}}</ol>
                        <li v-for="(item,index) in mtzx" :key="index" @click="selectStyle(item,index)">{{$t(item.title)}}</li>
                    </ul>
                </el-col>
                <el-col :span="6">
                    <ul>
                        <ol>{{$t('message.footer.shop')}}</ol>
                        <li v-for="(item,index) in zxsc" :key="index" @click="selectStyle(item,index)">{{$t(item.title)}}</li>
                    </ul>
                </el-col>
                <el-col :span="6">
                    <ul>
                        <ol>{{$t('message.footer.about')}}</ol>
                        <li v-for="(item,index) in gywm" :key="index" @click="selectStyle(item,index)">{{$t(item.title)}}</li>
                    </ul>
                </el-col>
            </el-col>

            <el-col :span="10" class="footer_code">
                <el-col :span="6">
                    <div class="code_img"><img class="w-100 pd-10" :src="footer_info.wx_code" /> </div>
                    <div>{{$t('message.footer.wx')}}</div>
                </el-col>
                <el-col :span="6">
                    <div class="code_img"><img class="w-100" style="padding: 10px;" :src="footer_info.wb_code" /> </div>
                    <div>{{$t('message.footer.wb')}}</div>
                </el-col>
                <el-col :span="12" class="footer_tel">
                    <div>{{$t('message.footer.ser_tel')}}</div>
                    <div class="color_block">{{footer_info.pc_mobile}}</div>
                    <div>{{footer_info.customer_time}}</div>
                    <div>{{$t('message.footer.friendLink')}}：<a href="https://www.jddmoto.com" style="color: #fff;" target="blank">{{$t('message.footer.links')}}</a></div>
                </el-col>
            </el-col>
        </el-row>
        <div  style="line-height: 20px;padding-bottom:15px;text-align: center;color: #fff;" v-if="footer_info.pc_bottom_text" v-html="footer_info.pc_bottom_text">

        </div>
        <!--<el-row class="footer_row">-->
            <!--{{footer_info.pc_bottom_text}}-->
        <!--</el-row>-->
        <Right_service :service_data="service_data"></Right_service>
    </div>
</template>

<script>
    import Right_service from "@/components/right_service.vue";
    export default {
        name: 'footerbox',
        components: {
            Right_service
        },
        data () {
            return {
                footer_info:{},
                wjfw:[
                    {id:1,title:'message.wjfw.wdcx',selec:false,path:'contact_us'},
                    {id:2,title:'message.wjfw.yjbx',selec:false,path:'repair'},
                    {id:3,title:'message.wjfw.wjzs',selec:false,path:'application'},
                    {id:4,title:'message.wjfw.wjapp',selec:false,path:'upload_app'},
                    {id:5,title:'message.wjfw.dzb',selec:false,path:'version_uploade'}
                ],
                mtzx:[
                    {article_id:0,title:'message.mtzx.zxzx',selec:false,path:'news',type:0},
                    {article_id:1,title:'message.mtzx.jcsp',selec:false,path:'news',type:3},
                    {article_id:2,title:'message.mtzx.cylt',selec:false,path:'forum'}
                ],
                zxsc:[
                    {article_id:109,title:'message.zxsc.tm_shop',selec:false,path:'article',type:31},
                    {article_id:110,title:'message.zxsc.jd_shop',selec:false,path:'article',type:32}
                ],
                gywm:[
                    {article_id:10,title:'message.gywm.ppgs',selec:false,path:'introduction',type:1},
                    {article_id:11,title:'message.gywm.lssj',selec:false,path:'introduction',type:2}
                ],
                service_data:{
                    pc_address:{
                        val:'',
                        show:false
                    },
                    pc_mobile:{
                        val:'',
                        show:false
                    }
                },
                jd_url:'',
                tm_url:'',


            }
        },
        methods:{
            get_setting(){
                var _this = this;
                var setting = localStorage.getItem('setting');
                if(setting){
                    setting = JSON.parse(setting);
                    _this.jb_url = setting.jd_url;
                    _this.tm_url = setting.tm_url;
                    _this.footer_info = setting;
                    _this.service_data.pc_address.val = setting.pc_address;
                    _this.service_data.pc_mobile.val = setting.pc_mobile;
                    _this.jb_url = setting.jd_url;
                    _this.tm_url = setting.tm_url;
                }else{
                    //url	/index.php?m=Mobile&c=Index&a=get_setting
                    var url = this.config.http_url+'/index.php?m=Mobile&c=Index&a=get_setting';
                    var params={};
                    this.$reshttp.post(url,params,{emulateJSON:true}).then(function(res){
                        if(res.body.code==200){
                            _this.footer_info = res.body.datas;
                            _this.service_data.pc_address.val = res.body.datas.pc_address;
                            _this.service_data.pc_mobile.val = res.body.datas.pc_mobile;
                            _this.jb_url = res.data.datas.jd_url;
                            _this.tm_url = res.data.datas.tm_url;
                        }else{

                        }
                    },function(res){
                        console.log(res);
                    });
                }

            },
            selectStyle(v,index,num) {

                if(v.type == 31 || v.type == 32 ){
                    var _this=this;
                    if(v.type == 31){
                        window.open(_this.tm_url);
                    }else if(v.type == 32){
                        window.open(_this.jb_url);
                    }
                }else{
                    this.$router.push({
                        path: v.path,
                        name: v.path,
                        query: {
                            article_id:v.article_id,
                            type:v.type
                        }
                    })
                }
            },
        },
        beforeCreate: function(){

        },
        created: function(){

        },
        beforeMount:function(){

        },
        mounted: function(){
            var _this = this;
            _this.swipe_img = this.img_list;
            this.get_setting();

        },
        beforeUpdate:function(){

        },
        updated:function(){

        },
        beforeDestroy:function(){

        },
        destroyed:function(){

        }

    }
</script>

<style scoped>
    #footerbox{
        /*margin-top: 10px;*/
        background: #1a1a1a;
        position: relative;
        z-index: 1;
    }
    .color_block{
        color: #fff;
        font-size: 18px;
        font-weight: bolder;
    }
    .footer_cont_box{
        width: 1200px;
        color: #ccc;
        margin: 0 auto;
    }
    .footer_details_box{
        border-right: 1px solid #dcdcdc;
        margin: 30px 0;
    }
    .footer_details_box li{
        cursor: pointer;
        margin: 10px 0;
    }
    .footer_details_box li:hover{
        color: #ccc;
    }
    .footer_details_box ul{

    }
    .footer_details_box ul ol{
        font-weight: 800;
        font-size: 16px;
        color: #fff;
    }
    .footer_details_box ul li{
        margin-top: 5px;
    }
    .footer_row{
        border-top: 2px solid #dcdcdc;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #1a1a1a;
    }
    .footer_code{
        padding: 30px 0px 30px 10px;
        text-align: center;
    }
    .footer_code div{
        padding-bottom: 5px;
    }
    .footer_tel{
        text-align: center;
    }
    .code_img >img{
        width: 120px;
        height: 120px;
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue